import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChartUserByCountry from '../ChartUserByCountry';
import CustomizedDataGrid from '../CustomizedDataGrid';
import CustomizedTreeView from '../CustomizedTreeView';
import Copyright from '../internals/components/Copyright';
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../../firebase"; 
import { useContext } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { EventContext } from "../../../pages/Dashboard";
import { useParams, Outlet } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";

const Posts = ({ eventDocId }) => {

  const {eventDetails} = useContext(EventContext); 
  const eventCode = eventDetails?.eventCode;  
  const eventID = eventDetails?.eventId; 
  const [guestRows, setGuestRows] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      if (!eventCode) return;

      const guestsRef = collection(db, "events", eventID, "posts");
      const snapshot = await getDocs(guestsRef);

      const rows = snapshot.docs.map((doc, index) => ({
        id: doc.id,
        postText: doc.data().postText,
        postLikes: doc.data().postLikes,
        postAuthorID: doc.data().postAuthorID,        
        timestamp: doc.data().timestamp?.toDate().toLocaleString() || "-",
      }));

      setGuestRows(rows);
    };

    fetchPosts();
  }, [eventCode]);

  const columns = [
    { field: "postText", headerName: "Post", width: 450 },
    { field: "postLikes", headerName: "Likes", width: 110 },
    { field: "postAuthorID", headerName: "Author", width: 150 },
    { field: "timestamp", headerName: "Created at", width: 200 },
  ];

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Posts {eventCode}
      </Typography>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Details
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
        <DataGrid
        rows={guestRows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        pagination
        pageSizeOptions={[5, 10, 25]}
        slots={{ toolbar: GridToolbar }}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
          sorting: { sortModel: [{ field: "guestEmail", sort: "asc" }] }
        }}
      />
         
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <CustomizedTreeView />
            <ChartUserByCountry />
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
};
export default Posts;